import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emulsions-page',
  templateUrl: './emulsions-page.component.html',
  styleUrls: ['./emulsions-page.component.scss']
})
export class EmulsionsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
